import { Component, inject } from "@angular/core";
import { AuthService } from "@core/services";
import { AuthPath } from "../../../app-routing.constants";
import { Bind } from "primeng/bind";
import { ButtonDirective } from "primeng/button";

@Component({
    selector: 'app-accessdenied',
    templateUrl: './app.accessdenied.component.html',
    styleUrl: '../http-exception.scss',
    imports: [Bind, ButtonDirective]
})
export class AppAccessdeniedComponent {
  private authService = inject(AuthService);

  loggedIn = this.authService.isLoggedIn$.value;

  protected readonly AuthPath = AuthPath;
}
